let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2IWA9")).then(() => parcelRequire('kwXal'));